import { render, staticRenderFns } from "./Vocation.vue?vue&type=template&id=96881bd4"
import script from "./Vocation.vue?vue&type=script&lang=ts"
export * from "./Vocation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports